// extracted by mini-css-extract-plugin
module.exports = {"pill":"CamHighlightsPill_pill__8NmDV","pillMinimalPlayer":"CamHighlightsPill_pillMinimalPlayer__jx0NZ"};